import { useTranslation } from 'react-i18next'

/**
 * Story E01.12 AC-12 — 500 placeholder. Used as TanStack Router's
 * `errorComponent` for the root route — fires when route loaders throw.
 * Uncaught render-time exceptions still bubble up to the React
 * `<ErrorBoundary>`, which has a friendlier surface (with Sentry id).
 */
export function ServerErrorPage() {
  const { t } = useTranslation()
  return (
    <div
      role="alert"
      className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center"
    >
      <h1 className="text-3xl font-semibold">500</h1>
      <p className="text-muted-foreground">{t('errors.server_error')}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-md border border-border bg-bg px-4 py-2 text-sm font-medium hover:bg-accent"
      >
        {t('errors.reload')}
      </button>
    </div>
  )
}
